<ui-field iconName="search" class="medium-margin-bottom" [label]="'BUTTONS.SEARCH' | translate">
    <input advizeoInput type="text" [ngModel]="search$ | async" (ngModelChange)="search$.next($event)" />
</ui-field>

<div class="y-scroll">
    <div class="catalog">
        <widget-catalog-item
            [title]="'COMPONENTS.WIDGET_PICKER.BI_WIDGET_CREATION' | translate"
            [thumbnailImg]="widget_thumbnail_url"
            (click)="requestBusinessIntelligenceWidgetCreation()"
        />
    </div>

    <h6>{{ 'COMPONENTS.WIDGET_PICKER.TEMPLATE_WIDGET_CREATION' | translate }}</h6>
    <div class="catalog">
        @for (item of tailoredWidgetTemplateList$ | async; track item) {
            <div>
                <widget-catalog-item
                    [title]="item.code | referenceListLabel: 'widgetTemplate'"
                    [thumbnailImg]="item.widgetTemplateId | applyPureFunction: getTemplateThumbnailUrl$ | async"
                    (click)="requestWidgetCreationFromTemplate(item.widgetTemplateId)"
                />
            </div>
        }
    </div>
    @if (!(tailoredWidgetTemplateList$ | async)?.length) {
        <div>
            <loading-and-error
                noDataTitle="COMPONENTS.WIDGET_PICKER.NO_WIDGET_TEMPLATE_TITLE"
                noDataMessage="COMPONENTS.WIDGET_PICKER.NO_WIDGET_TEMPLATE_MESSAGE"
                [hasNoData]="true"
                [noDataPictureUrl]="widget_thumbnail_url"
            />
        </div>
    }

    <h6>{{ 'COMPONENTS.WIDGET_PICKER.TAILORED_WIDGET_CREATION' | translate }}</h6>
    <div class="catalog">
        @for (item of tailoredWidgetList$ | async; track item.widgetId) {
            <div>
                <widget-catalog-item
                    [title]="item.name"
                    [label]="item.type"
                    [thumbnailImg]="item.widgetId | applyPureFunction: getThumbnailUrl$ | async"
                    (click)="onTailoredWidgetSelection(item.widgetId)"
                >
                    @if (
                        { widgetId: item.widgetId, dashboardType: input().targetDashboardScopeType }
                            | applyPureFunction: isWidgetEditable$
                            | async
                    ) {
                        <ui-icon-button
                            class="configure-button"
                            action
                            iconName="configure"
                            size="small"
                            [advizeoTooltip]="'BUTTONS.CONFIGURE' | translate"
                            (click)="requestWidgetEdition(item.widgetId); $event.stopPropagation()"
                        />
                    }
                    @if (
                        { widgetId: item.widgetId, dashboardType: input().targetDashboardScopeType }
                            | applyPureFunction: isWidgetDuplicable$
                            | async
                    ) {
                        <ui-icon-button
                            class="configure-button"
                            action
                            iconName="copy"
                            size="small"
                            [advizeoTooltip]="'BUTTONS.COPY' | translate"
                            (click)="requestWidgetDuplication(item.widgetId); $event.stopPropagation()"
                        />
                    }
                    @if (
                        { widgetId: item.widgetId, dashboardType: input().targetDashboardScopeType }
                            | applyPureFunction: isWidgetDeletable$
                            | async
                    ) {
                        <ui-icon-button
                            class="delete-button"
                            action
                            iconName="delete"
                            size="small"
                            [advizeoTooltip]="'BUTTONS.DELETE' | translate"
                            (click)="requestWidgetDeletion(item.widgetId); $event.stopPropagation()"
                        />
                    }
                </widget-catalog-item>
            </div>
        }
    </div>

    @if (!(tailoredWidgetList$ | async)?.length) {
        <div>
            <loading-and-error
                noDataPictureUrl="https://cdn.advizeo.io/img/widgets/widget.svg"
                noDataTitle="COMPONENTS.WIDGET_PICKER.NO_WIDGET_TITLE"
                noDataMessage="COMPONENTS.WIDGET_PICKER.NO_WIDGET_MESSAGE"
                [hasNoData]="true"
            />
        </div>
    }
</div>
